import React from 'react'
import Head from 'next/head'
import ThemeColorClient from './theme-color-client'

type Props = {
  themeColor: string
}

export const ThemeColor = ({ themeColor }: Props) => (
  <Head>
    <meta name="theme-color" content={themeColor} />
  </Head>
)

export default ThemeColorClient
